import axios from 'axios'

//const API_SERVER_DEVELOPMENT = 'http://localhost:15002'
//const API_SERVER_PRODUCTION = 'https://backendurbanor.banticapps.com'
const API_SERVER_PRODUCTION = 'https://pagosqr.azure.urbanor.com.bo'


//const API = process.env.REACT_APP_API_SERVER || API_SERVER_DEVELOPMENT
const API = process.env.REACT_APP_API_SERVER || API_SERVER_PRODUCTION

const instance = axios.create({
    baseURL: API,
    withCredentials: true, // es para establecer las cookies en axios
});

export default instance